import { ICreateApplicationVersionForm } from "../forms/i-create-application-version.form";
import { IAppVersionRestClient } from "./i-app-version-rest.client";
import { HttpClient } from "@angular/common/http";
import { HostUtil } from "../../../utils/host-util";
import { firstValueFrom, Observable } from "rxjs";
import { ARestClient, ICreateRecordResponse, IOkResponse, IPage, ISort } from "@zaeper/communication-lib";
import { IUpdateApplicationVersionForm } from "../forms/i-update-application-version.form";
import { Injectable } from "@angular/core";
import { IAppVersion } from "../../../models/application-version/i-app-version";
import { IGetAppVersionPageForm } from "./forms/i-get-app-version-page.form";

@Injectable()
export class AppVersionRestClient extends ARestClient implements IAppVersionRestClient {
  constructor(private readonly _httpClient: HttpClient) {
    super();
  }

  createAppVersion(
    appId: string,
    createApplicationVersionForm: ICreateApplicationVersionForm
  ): Promise<ICreateRecordResponse> {
    const endpointUrl: string = super.getEndpointUrl( HostUtil.getApplicationApiEndpointUrl(), `v1/app/${ appId }/version` );

    return firstValueFrom( this._httpClient.post( endpointUrl, createApplicationVersionForm, { withCredentials: true } ) as Observable<ICreateRecordResponse> );
  }

  updateAppVersion(
    appVersionId: string,
    appId: string,
    updateAppVersionForm: IUpdateApplicationVersionForm
  ): Promise<IOkResponse> {
    const endpointUrl: string = super.getEndpointUrl( HostUtil.getApplicationApiEndpointUrl(), `v1/app/${ appId }/version/${ appVersionId }` );

    return firstValueFrom( this._httpClient.put( endpointUrl, updateAppVersionForm, { withCredentials: true } ) as Observable<IOkResponse> );
  }

  deleteAppVersion(
    appVersionId: string,
    appId: string
  ): Promise<IOkResponse> {
    const endpointUrl: string = super.getEndpointUrl( HostUtil.getApplicationApiEndpointUrl(), `v1/app/${ appId }/version/${ appVersionId }` );

    return firstValueFrom( this._httpClient.delete( endpointUrl, { withCredentials: true } ) as Observable<IOkResponse> );
  }

  getAppVersionPage(
    appId: string,
    getAppVersionPageForm: IGetAppVersionPageForm
  ): Promise<IPage<IAppVersion>> {
    const endpointUrl: string = super.getEndpointUrl( HostUtil.getApplicationApiEndpointUrl(), `v1/app/${ appId }/version/page` );

    const defaultSort: ISort = {
      field: "versionNumber",
      ascending: true
    };

    return firstValueFrom( this._httpClient.get( endpointUrl, {
      withCredentials: true,
      params: {
        pageNumber: getAppVersionPageForm.pageNumber,
        pageSize: getAppVersionPageForm.pageSize,
        sort: super.serializeSort( defaultSort )
      }
    } ) as Observable<IPage<IAppVersion>> );
  }
}
